import { createSlice } from '@reduxjs/toolkit';
import {
  createCompanyFulfilled,
  getUserCompaniesFulfilled,
  postProfitAndLossFulfilled
} from 'state/actions/companyActions';
import {
  loginFulfilled,
  logoutFulfilled,
  signUpFulfilled,
  setQuickbooksYearFulfilled,
  updateSession
} from 'state/actions/userActions';

const initialState = {
  authenticated: false,
  user: null,
  hasCompanies: false,
  quickbooksYear: null,
  companyId: null,
  info: {}
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  extraReducers: {
    [loginFulfilled]: (state, { payload }) => {
      state.user = payload.user;
      state.hasCompanies = payload.hasCompanies;
      state.info = payload;
    },
    [signUpFulfilled]: (state, { payload }) => {
      state.user = payload;
    },
    [logoutFulfilled]: () => initialState,
    [updateSession]: (state, { payload }) => {
      state.info = payload;
      state.authenticated = true;
    },
    [createCompanyFulfilled]: (state, { payload }) => {
      // TODO, change to a easier access property when creating a company
      state.hasCompanies = true;
      state.companyId = payload.identifiers[0].id;
    },
    [setQuickbooksYearFulfilled]: (state, { payload }) => {
      state.quickbooksYear = payload;
    },
    [getUserCompaniesFulfilled]: (state, { payload }) => {
      state.companyId = payload[0].company.id;
    },
    [postProfitAndLossFulfilled]: state => {
      state.quickbooksYear = null;
    }
  }
});

export default sessionSlice.reducer;
